export default {
	setOurCertificates(state, our_certificates) {
		state.our_certificates = our_certificates
	},
}
